var $ = require('jquery');
$(function() {
    $('.mobile-nav-toggle button').on('click', function() {
        $(this).toggleClass('is-active');
        $('#navigation').slideToggle();
    });
});